import contractCostService from '../services/contractcost.service';
// import moment from 'moment'


const getDefaultState = () => {
  return {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    listItems: [],
    list_suppliers: [],
    total_lists_amount: {}
  }
}

export const contractCostList = {
  namespaced: true,
  state: {
    stateData: getDefaultState()
  },
  actions: {
    resetState({commit}) {
      commit("resetState");
    },
    getListSupplier({commit}, page=1, size=-1, type=1) {
			return contractCostService.getListSupplier(page, size, type).then(
				(response) => {
					return Promise.resolve(response);
				},
				(error) => {
					commit('getListSupplierFailure');
					return Promise.reject(error);
				}
			);
		},
    searchContractCost({commit}, conditions) {
      return contractCostService.searchContractCost(conditions).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit('searchContractCostFailure');
          return Promise.reject(error);
        }
      );
    },
    deleteContractCost ({commit}, id="") {
      return contractCostService.deleteContractCost(id).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit('deleteFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    resetState (state) {
      console.log("run resetState");
      Object.assign(state.stateData, getDefaultState());
    },
		getListSupplierFailure(state) {
			state.stateData.list_suppliers = [];
		},
    searchContractCostFailure() {
      console.log("run searchContractCostFailure");
    }
  },
  getters: {

  }
}